import React from "react";
import { makeStyles, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  mainLayout: {
    width: "100%",
  },
}));

const Main = ({ children }) => {
  const classes = useStyles();
  return (
    <Paper elevation={2} className={classes.mainLayout}>
      {children}
    </Paper>
  );
};

export default Main;
